import React from 'react'
import Button from '../Button/Button'
import { Facebook, GoogleColor } from '../Icons'

const SocialButton = ({ icon, social, className, ...props }) => {
  const socialIcon =
    icon || (social === 'facebook' ? <Facebook /> : social === 'google' ? <GoogleColor /> : null)

  return (
    <Button
      {...{
        icon: socialIcon,
        icon_pos: 'left',
        variant: social === 'google' ? 'secondary' : 'primary',
        ...props,
        className: `social-button social-button--${social}${className ? ` ${className}` : ''}`,
      }}
    />
  )
}

export default SocialButton
